class Keys {
  static token = "token-key"
  static expires_in = "expires-in"
  static refresh_token = "refresh-token"
  static login_time = "login-time"
  static cityCode = "cityCode"
  static noLogincityCodeHome = "noLogincityCodeHome"
  static noLogincityCodeZy = "noLogincityCodeZy"
  static noLogincityCodeXm = "noLogincityCodeXm"
}

export default Keys
